import React from "react";
import loadable from "@loadable/component";
import PageLoader from "../../../components/PageLoader";

export default loadable(() => import("./terms"), { fallback: <PageLoader /> });
